import axios from 'axios'
import store from '@/store/index.js'
import Vue from 'vue'
import api from './api.js'
import Host from '@/common/config.js'
// axios 配置
axios.defaults.baseURL = Host.apiurl;
axios.defaults.timeout = 15000;
// /axios.defaults.headers.common['token'] = Vue.prototype.authToken;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
//aixos拦截器
axios.interceptors.request.use(
  config => {
    //头部token设置
    // var token = Vue.prototype.$store.state.authToken;
    // config.headers.token = token?token:'';
    config.headers.Token = window._method.getCookie('token');
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function SystemRequestPost(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(api[url], data)
      .then(response => {
        if (response.status == 200) {
          //if(response.data.code=='-1') return store.commit('userExamlogout'); //登录失效 清除登录状态 并返回登录
          console.log(response)
          resolve(response.data);
          return;
        }
        reject(err);
      }).catch(err => {
        reject(err)
      })
  });
};
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function SystemRequestGet(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(api[url], {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err)
    })
  });
}



// WEBPACK FOOTER //
// ./src/request/http.js